import { css } from 'linaria';

export const RootPageStyles = css`
	display: flex;
	flex-direction: column;
	flex: 1;
`;
